// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0717636d","135":"ac24ab54","224":"b4181037","481":"12314469","513":"cdf5fb63","567":"7c74e4d4","773":"9280b89b","962":"da41b05a"}[chunkId] + ".chunk.js";
};